import { Container } from 'pixi.js';
import { waitForMs } from '../../utils/async-utils';

export default function initWaitMixin(): void {
  Container.mixin({
    wait(amountMs: number): Promise<void> {
      return new Promise((resolve) => {
        waitForMs(amountMs).then(
          () => {
            if (!this.destroyed) resolve();
          },
          () => {},
        );
      });
    },
  });
}
